import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '../IconButton';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import palette from '@Utilities/styles/materialTheme/palette';
import { variantPropMap } from './services';
import './styles/appBar.scss';
import './styles/appBarV2.scss';

/** @component
 * @param {Object} props
 * @param {String} props.arrowBackIconColor - defaults to intended styling for Arrow Back Icon, pass in other color if needed
 * @param {Function} props.onBackClick - REQUIRED pass in default of browserHistory.goBack() or handler as needed
 */

export default function AppBar({
  title,
  variant = 'v1',
  className,
  onBackClick,
  showBackButton = true,
  arrowBackIconColor = palette.primary['40']
}) {
  const variantProp = variantPropMap[variant] || variantPropMap['v1'];

  return (
    <div className={`${variantProp.className} ${className || ''}`}>
      <div className={`${variantProp.className}__left`}>
        <div className={`${variantProp.className}__left__back`}>
          {showBackButton && (
            <IconButton
              onClick={onBackClick}
              data-testid='app-bar--v2-back'
              variant={variantProp.iconButtonVariant}
            >
              <ArrowBackIcon sx={{ color: arrowBackIconColor }} />
            </IconButton>
          )}
        </div>
        {title && <div className={`${variantProp.className}__left__header`}>{title}</div>}
      </div>
    </div>
  );
}

AppBar.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  variant: PropTypes.oneOf(['v1', 'v2']),
  className: PropTypes.string,
  onBackClick: PropTypes.func.isRequired,
  showBackButton: PropTypes.bool,
  arrowBackIconColor: PropTypes.string
};
